import nl2br from 'react-nl2br';
import { UsernameWithBadges } from '~/app/_components/username-with-badge/username-with-badge';
import type { StoryComment } from '~/common/types/story-comment';
import type { UserOverview } from '~/common/types/user-overview';
import { formatNotificationDateString } from '~/utils/formats';
import { routes } from '~/utils/routes';
import noImage from '@app/_assets/no-image.png';
import { Link } from '@app/_components/link';
import {
  VstackProps,
  VStack,
  Paragraph,
  HStack,
  Image,
  Box,
} from '@styled-system/jsx';
import commentAuthorTip from './assets/comment-tip-author.svg';
import commentTip from './assets/comment-tip.svg';

export type CommentItemProps = {
  storyId: string;
  author?: Pick<UserOverview, 'id' | 'name' | 'thumbnailUrl'>;
  comment: StoryComment;
} & VstackProps;

export const CommentItem = ({
  storyId,
  comment,
  author,
  ...vstackProps
}: CommentItemProps) => {
  const isAuthor = comment.user.id === author?.id;

  return (
    <VStack w="100%" alignItems="flex-start" gap="1" p="4" {...vstackProps}>
      <HStack gap="16px" w="100%">
        <Link href={routes.user.userDetail.url(comment.user.id)}>
          <Image
            alt={comment.user.name ?? 'ゲスト'}
            src={comment.user.thumbnailUrl ?? noImage}
            w="40px"
            h="40px"
            borderRadius="50%"
          />
        </Link>
        <UsernameWithBadges
          userId={comment.user.id}
          username={comment.user.name}
          isOfficialWriter={comment.user.isOfficialWriter}
          isVip={comment.user.isVip}
        />
        {comment.createdAt && (
          <Paragraph fontSize="size_12" color="gray_500">
            {formatNotificationDateString(comment.createdAt)}
          </Paragraph>
        )}
      </HStack>

      <Box ml="48px" position="relative">
        {comment.text && (
          <>
            <Image
              src={isAuthor ? commentAuthorTip : commentTip}
              alt="コメント"
              w="12px"
              h="11px"
              position="absolute"
              left="-4px"
            />
            <Paragraph
              bg={isAuthor ? '#9ADE60' : 'accent.50'}
              p="3"
              color={comment.isDeleted ? 'accent.500' : 'accent.1000'}
              borderRadius="18px"
            >
              {nl2br(comment.text.body)}
            </Paragraph>
          </>
        )}
        {comment.stamp && (
          <Image
            maxHeight="70px"
            position="relative"
            top="5px"
            src={comment.stamp.imageUrl}
            alt={comment.stamp.alt}
          />
        )}
      </Box>
    </VStack>
  );
};
